import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  ResourceDataSlice,
  Slice,
  SliceType,
} from '@flowx/designer/modules/core/dictionary/data-mapping.dictionary'
import { Optional } from '@flowx/designer/shared/typescript-utils'

export const NodeSlicesActions = createActionGroup({
  source: 'NODE SLICES',
  events: {
    getNodeSlices: props<{ nodeFlowxUuid: string }>(),
    getNodeSlicesSuccess: props<{ nodeSlices: ResourceDataSlice[]; nodeFlowxUuid: string }>(),
    getNodeSlicesFailure: props<{ nodeFlowxUuid: string }>(),
    createNodeSlice: props<{
      nodeFlowxUuid: string
      sliceType: SliceType
      sliceItems: Omit<Slice, 'id'>[]
    }>(),
    createNodeSliceSuccess: props<{ nodeSlice: ResourceDataSlice; nodeFlowxUuid: string }>(),
    createNodeSliceFailure: props<{ nodeFlowxUuid: string }>(),
    updateNodeSlice: props<{
      nodeFlowxUuid: string
      slice: Omit<ResourceDataSlice, 'sliceItems'> & { sliceItems: Optional<Slice, 'id'>[] }
    }>(),
    updateNodeSliceSuccess: props<{ nodeSlice: ResourceDataSlice; nodeFlowxUuid: string }>(),
    updateNodeSliceFailure: props<{ nodeFlowxUuid: string }>(),
    cleanupNodeSlices: emptyProps(),
  },
})
